import { useEffect } from 'react'

import Api from 'services/api'

import { useStoreContext } from 'hooks/StoreContext'

const useTrends = () => {
  const { trends, setTrends, areTrendsLoaded, setAreTrendsLoaded } = useStoreContext()

  useEffect(() => {
    if (areTrendsLoaded) {
      return
    }

    setAreTrendsLoaded(false)

    Api.DeviceMetrics.getTrends()
      .then((res) => {
        setTrends(res)
        setAreTrendsLoaded(true)
      })
      .catch(() => {
        setTrends(null)
        setAreTrendsLoaded(true)
      })
  }, [trends, areTrendsLoaded, setAreTrendsLoaded, setTrends])

  return { trends, areTrendsLoaded }
}

export default useTrends
